export default __webpack_public_path__ + "static/heero-2ed8c894da0b89380db13b27af038c8f.webp";